<app-widget-consentimiento
  [modal]="true"
  [posicion]="posicion"
  [abierto]="true"
  [tema]="null"
  [ocultarSiNoHayInteraccion]="false"
  [mostrarBotonCerrar]="true"
  [colorTexto]="colores.texto"
  [colorFondo]="colores.fondo"
  [colorBoton]="colores.boton"
  [colorTextoBoton]="colores.textoBoton"
  [colorMasInfo]="colores.masInfo ?? '#1b2635'"
  [codSociedad]="codSociedad"
  [codTipoFormulario]="codTipoFormulario"
  [rut]="rut"
  [nombres]="nombres"
  [apellidos]="apellidos"
  [email]="email"
  [telefono]="telefono"
></app-widget-consentimiento>
